import { useContext } from 'react';
import ThemeContext from '../contexts/themeContext';

export default function useUpdateHeader() {
	const { updateHeaderStatus, setUpdateHeaderStatus } = useContext(ThemeContext);

	return { updateHeaderStatus, setUpdateHeaderStatus };
}
